/* eslint-disable lines-around-comment */
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import _ from 'lodash';
import React, { PureComponent } from 'react';
import { FixedSizeGrid, FixedSizeList } from 'react-window';
import { keyframes } from 'styled-components';
import { ACTION_SHORTCUT_TRIGGERED, createShortcutEvent, createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { getToolbarButtons } from '../../../base/config/functions.web';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import Icon from '../../../base/icons/components/Icon';
import { IconArrowDown, IconArrowUp } from '../../../base/icons/svg';
import { connect } from '../../../base/redux/functions';
import { shouldHideSelfView } from '../../../base/settings/functions.web';
import { showToolbox } from '../../../toolbox/actions.web';
import { isButtonEnabled, isToolboxVisible } from '../../../toolbox/functions.web';
import { LAYOUTS } from '../../../video-layout/constants';
import { getCurrentLayout } from '../../../video-layout/functions.web';
import { setFilmstripVisible, setTopPanelVisible, setUserFilmstripHeight, setUserFilmstripWidth, setUserIsResizing, setVisibleRemoteParticipants } from '../../actions.web';
import { ASPECT_RATIO_BREAKPOINT, DEFAULT_FILMSTRIP_WIDTH, FILMSTRIP_TYPE, MIN_STAGE_VIEW_HEIGHT, MIN_STAGE_VIEW_WIDTH, TILE_HORIZONTAL_MARGIN, TILE_VERTICAL_MARGIN, TOP_FILMSTRIP_HEIGHT } from '../../constants';
import { getVerticalViewMaxWidth, isStageFilmstripTopPanel, shouldRemoteVideosBeVisible } from '../../functions.web';
import Thumbnail from './Thumbnail';
// @ts-ignore
import ThumbnailWrapper from './ThumbnailWrapper';
// @ts-ignore
import { styles } from './styles';
/**
 * Implements a React {@link Component} which represents the filmstrip on
 * Web/React.
 *
 * @augments Component
 */
class Filmstrip extends PureComponent {
    /**
     * Initializes a new {@code Filmstrip} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            isMouseDown: false,
            mousePosition: null,
            dragFilmstripWidth: null
        };
        // Bind event handlers so they are only bound once for every instance.
        this._onShortcutToggleFilmstrip = this._onShortcutToggleFilmstrip.bind(this);
        this._onToolbarToggleFilmstrip = this._onToolbarToggleFilmstrip.bind(this);
        this._onTabIn = this._onTabIn.bind(this);
        this._gridItemKey = this._gridItemKey.bind(this);
        this._listItemKey = this._listItemKey.bind(this);
        this._onGridItemsRendered = this._onGridItemsRendered.bind(this);
        this._onListItemsRendered = this._onListItemsRendered.bind(this);
        this._onToggleButtonTouch = this._onToggleButtonTouch.bind(this);
        this._onDragHandleMouseDown = this._onDragHandleMouseDown.bind(this);
        this._onDragMouseUp = this._onDragMouseUp.bind(this);
        this._onFilmstripResize = this._onFilmstripResize.bind(this);
        this._throttledResize = _.throttle(this._onFilmstripResize, 50, {
            leading: true,
            trailing: false
        });
    }
    /**
     * Implements React's {@link Component#componentDidMount}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        APP.keyboardshortcut.registerShortcut('F', 'filmstripPopover', this._onShortcutToggleFilmstrip, 'keyboardShortcuts.toggleFilmstrip');
        document.addEventListener('mouseup', this._onDragMouseUp);
        // @ts-ignore
        document.addEventListener('mousemove', this._throttledResize);
        /*         registerSound('nab-demo-legacy.wav', 'legacy');
                registerSound('nab-demo-hd.wav', 'hd');
                console.log('xxx didmount')
                // const store = useStore();
                const context = new AudioContext();
                const audio = document.createElement("audio");
                audio.src = "/sounds/nab-demo-legacy.wav";
                audio.load();
                console.log('xxx audio', audio)
                const source = context.createMediaElementSource(audio as HTMLMediaElement);
                const state = APP.store.getState();
                console.log('xxx source',source)
                console.log('xxx state',state)
                const localAudio = getLocalJitsiAudioTrack(state);
                console.log('xxx local',localAudio)
                localAudio.setEffect(source); */
        // launch the first modal dialog on page load without having to click the invite button
    }
    /**
     * Implements React's {@link Component#componentDidUpdate}.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        APP.keyboardshortcut.unregisterShortcut('F');
        document.removeEventListener('mouseup', this._onDragMouseUp);
        // @ts-ignore
        document.removeEventListener('mousemove', this._throttledResize);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const filmstripStyle = {};
        const { _currentLayout, _disableSelfView, _localScreenShare, _mainFilmstripVisible, _resizableFilmstrip, _topPanelFilmstrip, _topPanelMaxHeight, _topPanelVisible, _verticalViewBackground, _verticalViewGrid, _verticalViewMaxWidth, classes, filmstripType, _participants } = this.props;
        const { isMouseDown } = this.state;
        const tileViewActive = _currentLayout === LAYOUTS.TILE_VIEW;
        const filmstripRemoteVideosContainerStyle = {};
        let remoteVideoContainerClassName = 'remote-videos-container';
        switch (_currentLayout) {
            case LAYOUTS.VERTICAL_FILMSTRIP_VIEW:
                // Adding 18px for the 2px margins, 2px borders on the left and right and 5px padding on the left and right.
                // Also adding 7px for the scrollbar.
                filmstripStyle.maxWidth = 120 + 25;
                break;
            case LAYOUTS.TILE_VIEW: {
                // The size of the side margins for each tile as set in CSS.
                const { _columns, _rows, _filmstripWidth } = this.props;
                if (_rows > _columns) {
                    remoteVideoContainerClassName += ' has-overflow';
                }
                filmstripRemoteVideosContainerStyle.width = _filmstripWidth;
                break;
            }
        }
        let remoteVideosWrapperClassName = 'filmstrip__videos';
        if (this.props._hideScrollbar) {
            remoteVideosWrapperClassName += ' hide-scrollbar';
        }
        let isDemo = false;
        const audioMovesFdr = keyframes `
          0% {
            width: 100%;
          }
          10% {
            width: 80%;
          }
          20% {
            width: 85%;
          }
          30% {
            width: 100%;
          }
          40% {
            width: 100%;
          }
          50% {
            width: 100%;
          }
          60% {
            width: 100%;
          }
          70% {
            width: 70%;
          }
          80% {
            width: 60%;
          }
          90% {
            width: 100%;
          }
          100% {
            width: 100%;
          }`;
        const audioMovesStalin = keyframes `
          0% {
            width: 100%;
          }
          10% {
            width: 100%;
          }
          20% {
            width: 100%;
          }
          30% {
            width: 80%;
          }
          40% {
            width: 90%;
          }
          50% {
            width: 70%;
          }
          60% {
            width: 100%;
          }
          70% {
            width: 100%;
          }
          80% {
            width: 100%;
          }
          90% {
            width: 100%;
          }
          100% {
            width: 100%;
          }`;
        const audioMovesChurchill = keyframes `
          0% {
            width: 100%;
          }
          10% {
            width: 100%;
          }
          20% {
            width: 100%;
          }
          30% {
            width: 100%;
          }
          40% {
            width: 100%;
          }
          50% {
            width: 70%;
          }
          60% {
            width: 60%;
          }
          70% {
            width: 100%;
          }
          80% {
            width: 100%;
          }
          90% {
            width: 100%;
          }
          100% {
            width: 100%;
          }`;
        // if the local user is miruna or tom, then replace _participants with moderator and guests
        Object.keys(_participants).map(function (key, index) {
            var _a, _b;
            if (key === 'local') {
                //@ts-ignore
                if (((_a = _participants[key]) === null || _a === void 0 ? void 0 : _a.email) === 'miruna.caramangiu@gmail.com' || ((_b = _participants[key]) === null || _b === void 0 ? void 0 : _b.email) === 'knowhow@innovationsapplied.com') {
                    //@ts-ignore
                    // console.log("xxx local email: ", _participants[key]?.email);
                    isDemo = true;
                }
            }
        });
        /*          console.log("xxx participants - all", _participants);
        
                 Object.keys(_participants).map(function(key: any, index)  {
                     if (key === 'local'){
                        console.log("xxx key: ",key);
                        console.log("xxx local key: ",_participants[key]);
                        //@ts-ignore
                        console.log("xxx local email: ",_participants[key]?.email);
                        //@ts-ignore
                        console.log("xxx local local: ",_participants[key]?.local);
                        //@ts-ignore
                        console.log("xxx local id: ",_participants[key]?.id);
                    }
                    if (key === 'remote'){
                        //@ts-ignore
                        [..._participants[key].values()].forEach((x) => {
                            console.log("xxx remote values spread.from: ", x);
                            //@ts-ignore
                            console.log("xxx remote value email spread.from: ", x?.email);
                            //console.log("xxx props email moderator: ", this.props?.settings?.emailModerator);
                            //console.log("xxx props settings mode: ", this.props?.settings?.mode);
                            //@ts-ignore
                            console.log("xxx remote value local spread.from: ", x?.local);
                            //@ts-ignore
                            console.log("xxx remote value id spread.from: ", x?.id);
                        });
                        console.log("xxx key: ",key);
                        //@ts-ignore
                        console.log("xxx remote key: ",_participants[key]);
                        //@ts-ignore
                        console.log("xxx remote key size: ",_participants[key]?.size);
                        //@ts-ignore
                    };
        
                }); */
        /*
        //@ts-ignore
        for (const x of _participants[key].values()) {
            console.log("xxx remote values: ", x);
            console.log("xxx remote value email: ", x?.email);
            //console.log("xxx props email moderator: ", this.props?.settings?.emailModerator);
            //console.log("xxx props settings mode: ", this.props?.settings?.mode);
            console.log("xxx remote value local: ", x?.local);
            console.log("xxx remote value id: ", x?.id);
        };
        //@ts-ignore
        [..._participants[key].values()].forEach((x) => {
            console.log("xxx remote values spread.from: ", x);
            //@ts-ignore
            console.log("xxx remote value email spread.from: ", x?.email);
            //console.log("xxx props email moderator: ", this.props?.settings?.emailModerator);
            //console.log("xxx props settings mode: ", this.props?.settings?.mode);
            //@ts-ignore
            console.log("xxx remote value local spread.from: ", x?.local);
            //@ts-ignore
            console.log("xxx remote value id spread.from: ", x?.id);
        });
        //@ts-ignore
        [..._participants[key].values()].map( (x: { email: any; local: any; id: any; }) => {
            console.log("xxx remote values spread map: ", x);
            //@ts-ignore
            console.log("xxx remote value email spread map: ", x?.email);
            //console.log("xxx props email moderator: ", this.props?.settings?.emailModerator);
            //console.log("xxx props settings mode: ", this.props?.settings?.mode);
            //@ts-ignore
            console.log("xxx remote value local spread map: ", x?.local);
            //@ts-ignore
            console.log("xxx remote value id spread map: ", x?.id);
        });
        //@ts-ignore
        Array.from(_participants[key].values()).map( (x) => {
            console.log("xxx remote values array.from: ", x);
            //@ts-ignore
            console.log("xxx remote value email array.from: ", x?.email);
            //console.log("xxx props email moderator: ", this.props?.settings?.emailModerator);
            //console.log("xxx props settings mode: ", this.props?.settings?.mode);
            //@ts-ignore
            console.log("xxx remote value local array.from: ", x?.local);
            //@ts-ignore
            console.log("xxx remote value id array.from: ", x?.id);
        });

    }
  }); */
        return (React.createElement("div", { className: 'filmstrip filmstrip-container filmstrip-container-500' },
            React.createElement("div", { className: this.props._videosClassName, id: 'remoteVideos' },
                React.createElement("div", { className: remoteVideosWrapperClassName, id: 'filmstripRemoteVideos' },
                    React.createElement("div", { className: remoteVideoContainerClassName, id: 'filmstripRemoteVideosContainer' },
                        isDemo ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } }),
                            React.createElement("div", { style: { marginTop: '22px' } }),
                            React.createElement("div", { id: "item-recording", className: "item-recording item-recording-500" },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "wrap-avatar-toolbox" },
                                            React.createElement("img", { alt: "Gravatar for Churchill", src: "/images/churchill.png", srcSet: "//www.gravatar.com/avatar/7c9cf16444640321c0c04f02365db026?d=mp&r=g&s=80 2x", height: 40, width: 40, className: "react-gravatar" }))),
                                    React.createElement("div", { className: "display-name-comrex display-user-name-800" },
                                        React.createElement("span", { className: "displaynamecomrex", id: "participant_b77e20de_name" }, "Winston Churchill")),
                                    React.createElement("div", { className: "audio-wave-box audio-wave-box-hidden" },
                                        React.createElement("div", { className: "audio-wave-box-mask", style: { width: '100%', animation: audioMovesChurchill, animationDuration: '5s', animationIterationCount: 'infinite' } })),
                                    React.createElement("div", { className: "flex-audio", style: { display: 'flex' } },
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-pressed": "true", "aria-disabled": "true", "aria-label": "Toggle mute audio", className: "toolbox-button", tabIndex: 0, role: "button" },
                                                React.createElement("div", null,
                                                    React.createElement("div", { className: "toolbox-icon toggled toolbox-audio-toggle" },
                                                        React.createElement("div", { className: "jitsi-icon jitsi-icon-default " },
                                                            React.createElement("svg", { height: 24, width: 24, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
                                                                React.createElement("path", { d: "m5.688 4 22.313 22.313-1.688 1.688-5.563-5.563c-1 .625-2.25 1-3.438 1.188v4.375h-2.625v-4.375c-4.375-.625-8-4.375-8-8.938h2.25c0 4 3.375 6.75 7.063 6.75 1.063 0 2.125-.25 3.063-.688l-2.188-2.188c-.25.063-.563.125-.875.125-2.188 0-4-1.813-4-4v-1l-8-8zM20 14.875l-8-7.938v-.25c0-2.188 1.813-4 4-4s4 1.813 4 4v8.188zm5.313-.187a8.824 8.824 0 0 1-1.188 4.375L22.5 17.375c.375-.813.563-1.688.563-2.688h2.25z" }))))))),
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-disabled": "false", "aria-label": "Leave Gagl", className: "toolbox-button", tabIndex: 0, role: "button" },
                                                React.createElement("div", null,
                                                    React.createElement("div", { className: "toolbox-icon   hangup-or-kick-button" },
                                                        React.createElement("div", { className: "jitsi-icon jitsi-icon-default " },
                                                            React.createElement("svg", { height: 24, width: 24, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 44 31" },
                                                                React.createElement("image", { "data-name": "Vector Smart Object", width: 44, height: 31, xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAfCAYAAACcai8CAAAClUlEQVRYheWYv2sUQRTHP1mTgHJGPUURVE4RBVEQ/FEoKQ0KFipqpWhjo40kjf9FCkEQhBRpotiIjYooKCicgki0ELycFh5BxAj+CuHCV0ZmYVl393Z25zTgF4bZm3vz3vdm33znzfVIIicCYBuwG9gE1Gy/Elhq20CCq1lgBvhi+w9AA5gCXgMvgJ95SXQivBo4BhwF9gGVvI4dMA+8BO4Ct4A6kE7KEE5ouyTdkDSvv4+GpIuSKknc4gMrJI39A5JJmJZ0JovwFklTC4RsFBOSloQ8wxxeBzwH1nQhR33gAXAImAsJPwIGPTj+BkwD3yNjy4Flti+DUWDYED4M3HZ0ZGToqW2vbDMy9SNjTsVK4Q5gJ7Af2Av05YxpVna7yYubjjl1XVJ/irq4tmHH2JcDq68u6De5VPL1hkg6aLIwZAivdZyU+2jMgU+O9puDAqv11htdeOZoH/QCH62s5cWdDDvj76DtDdrWvp1ib47hN8DWnLE/Y4U5L+qSejI2Vi3BT63DRhxyKAEeBg6SZt7EKc85bHAPOBvT7jSMYSVqMuNXzUi6JmlDDskqssJhWyXpkqT3aasrKQiN10t6EvmyJemKpAOS+hy0tQzhsC2SdETSfZsqbUnjkgaitUSImt0wjYKv3sxvxsY2Au+K5Aqw2PKYDQd6YwZFHXcLf9xEggVGsCP+O8KngaqDfdXOKYyyhE8CLWC8Qz09aG1adk5xlCwPq5KaEQlL0tDoWNPOKRzT5X+JNJgi/LEtO7MwZ1e6XiaYj01nCIzksBspS/Y3PN0cOhVRE77i+EiJEBV7846XiqZ83AN89RHEpw6bG/Px2EXUPJ/wRZYuHBzm9nw+8vkCMOkzgM+UiOKqXYxzXr0CvwChP9p88bXmJQAAAABJRU5ErkJggg==" }))))))))),
                                React.createElement("div", { className: "audio-wave-box audio-wave-box-500 hidden-above-500" },
                                    React.createElement("div", { className: "audio-wave-box-mask", style: { width: '100%', animation: audioMovesChurchill, animationDuration: '5s', animationIterationCount: 'infinite' } }))),
                            React.createElement("div", { style: { marginTop: '22px' } }),
                            React.createElement("div", { id: "item-recording", className: "item-recording item-recording-500" },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "wrap-avatar-toolbox" },
                                            React.createElement("img", { alt: "Gravatar for Joseph Stalin", src: "/images/stalin.png", srcSet: "//www.gravatar.com/avatar/7c9cf16444640321c0c04f02365db026?d=mp&r=g&s=80 2x", height: 40, width: 40, className: "react-gravatar" }))),
                                    React.createElement("div", { className: "display-name-comrex display-user-name-800" },
                                        React.createElement("span", { className: "displaynamecomrex", id: "participant_618d9c47_name" }, "Joseph Stalin")),
                                    React.createElement("div", { className: "audio-wave-box audio-wave-box-hidden" },
                                        React.createElement("div", { className: "audio-wave-box-mask", style: { width: '100%', animation: audioMovesStalin, animationDuration: '5s', animationIterationCount: 'infinite' } })),
                                    React.createElement("div", { className: "flex-audio", style: { display: 'flex' } },
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-label": "Toggle mute audio", className: "toolbox-button flex-row button_recordding hover-button false undefined ", role: "button", tabIndex: 0, style: { position: 'relative', borderRadius: '4px' } },
                                                React.createElement("div", null,
                                                    React.createElement("div", null,
                                                        React.createElement("div", { className: "icon-button " },
                                                            React.createElement("div", { className: "jitsi-icon jitsi-icon-default " },
                                                                React.createElement("svg", { height: 22, width: 22, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
                                                                    React.createElement("path", { d: "M23.063 14.688h2.25c0 4.563-3.625 8.313-8 8.938v4.375h-2.625v-4.375c-4.375-.625-8-4.375-8-8.938h2.25c0 4 3.375 6.75 7.063 6.75s7.063-2.75 7.063-6.75zm-7.063 4c-2.188 0-4-1.813-4-4v-8c0-2.188 1.813-4 4-4s4 1.813 4 4v8c0 2.188-1.813 4-4 4z" })))))))),
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-label": "Leave Gagl", className: "toolbox-button flex-row button_recordding background-hangup hover-button false undefined ", role: "button", tabIndex: 0, style: { position: 'relative', borderRadius: '4px' } },
                                                React.createElement("div", null,
                                                    React.createElement("div", null,
                                                        React.createElement("div", { className: "icon-button " },
                                                            React.createElement("div", { className: "jitsi-icon jitsi-icon-default " },
                                                                React.createElement("svg", { height: 22, width: 22, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 44 31" },
                                                                    React.createElement("image", { "data-name": "Vector Smart Object", width: 44, height: 31, xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAfCAYAAACcai8CAAAClUlEQVRYheWYv2sUQRTHP1mTgHJGPUURVE4RBVEQ/FEoKQ0KFipqpWhjo40kjf9FCkEQhBRpotiIjYooKCicgki0ELycFh5BxAj+CuHCV0ZmYVl393Z25zTgF4bZm3vz3vdm33znzfVIIicCYBuwG9gE1Gy/Elhq20CCq1lgBvhi+w9AA5gCXgMvgJ95SXQivBo4BhwF9gGVvI4dMA+8BO4Ct4A6kE7KEE5ouyTdkDSvv4+GpIuSKknc4gMrJI39A5JJmJZ0JovwFklTC4RsFBOSloQ8wxxeBzwH1nQhR33gAXAImAsJPwIGPTj+BkwD3yNjy4Flti+DUWDYED4M3HZ0ZGToqW2vbDMy9SNjTsVK4Q5gJ7Af2Av05YxpVna7yYubjjl1XVJ/irq4tmHH2JcDq68u6De5VPL1hkg6aLIwZAivdZyU+2jMgU+O9puDAqv11htdeOZoH/QCH62s5cWdDDvj76DtDdrWvp1ib47hN8DWnLE/Y4U5L+qSejI2Vi3BT63DRhxyKAEeBg6SZt7EKc85bHAPOBvT7jSMYSVqMuNXzUi6JmlDDskqssJhWyXpkqT3aasrKQiN10t6EvmyJemKpAOS+hy0tQzhsC2SdETSfZsqbUnjkgaitUSImt0wjYKv3sxvxsY2Au+K5Aqw2PKYDQd6YwZFHXcLf9xEggVGsCP+O8KngaqDfdXOKYyyhE8CLWC8Qz09aG1adk5xlCwPq5KaEQlL0tDoWNPOKRzT5X+JNJgi/LEtO7MwZ1e6XiaYj01nCIzksBspS/Y3PN0cOhVRE77i+EiJEBV7846XiqZ83AN89RHEpw6bG/Px2EXUPJ/wRZYuHBzm9nw+8vkCMOkzgM+UiOKqXYxzXr0CvwChP9p88bXmJQAAAABJRU5ErkJggg==" })))))))),
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-label": "toolbar.accessibilityLabel.requestUnmute", className: "toolbox-button flex-row toolbox-audio-toggle request-button hover-button undefined undefined ", role: "button", tabIndex: 0, style: { position: 'relative', borderRadius: '4px' } },
                                                React.createElement("div", null,
                                                    React.createElement("div", { style: { paddingRight: '8px', paddingLeft: '10px' } },
                                                        React.createElement("span", { style: { fontSize: '13px', textTransform: 'uppercase', fontWeight: 'bold' } }, "!"))))))),
                                React.createElement("div", { className: "audio-wave-box audio-wave-box-500 hidden-above-500" },
                                    React.createElement("div", { className: "audio-wave-box-mask", style: { width: '100%', animation: audioMovesStalin, animationDuration: '5s', animationIterationCount: 'infinite' } }))),
                            React.createElement("div", { style: { marginTop: '22px' } }),
                            React.createElement("div", { id: "item-recording", className: "item-recording item-recording-500" },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "wrap-avatar-toolbox" },
                                            React.createElement("img", { alt: "Gravatar for Joseph Stalin", src: "/images/fdr.png", srcSet: "//www.gravatar.com/avatar/7c9cf16444640321c0c04f02365db026?d=mp&r=g&s=80 2x", height: 40, width: 40, className: "react-gravatar" }))),
                                    React.createElement("div", { className: "display-name-comrex display-user-name-800" },
                                        React.createElement("span", { className: "displaynamecomrex", id: "participant_618d9c47_name" }, "Franklin Roosevelt")),
                                    React.createElement("div", { className: "audio-wave-box audio-wave-box-hidden" },
                                        React.createElement("div", { className: "audio-wave-box-mask", style: { width: '100%', animation: audioMovesFdr, animationDuration: '5s', animationIterationCount: 'infinite' } })),
                                    React.createElement("div", { className: "flex-audio", style: { display: 'flex' } },
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-label": "Toggle mute audio", className: "toolbox-button flex-row button_recordding hover-button false undefined ", role: "button", tabIndex: 0, style: { position: 'relative', borderRadius: '4px' } },
                                                React.createElement("div", null,
                                                    React.createElement("div", null,
                                                        React.createElement("div", { className: "icon-button " },
                                                            React.createElement("div", { className: "jitsi-icon jitsi-icon-default " },
                                                                React.createElement("svg", { height: 22, width: 22, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
                                                                    React.createElement("path", { d: "M23.063 14.688h2.25c0 4.563-3.625 8.313-8 8.938v4.375h-2.625v-4.375c-4.375-.625-8-4.375-8-8.938h2.25c0 4 3.375 6.75 7.063 6.75s7.063-2.75 7.063-6.75zm-7.063 4c-2.188 0-4-1.813-4-4v-8c0-2.188 1.813-4 4-4s4 1.813 4 4v8c0 2.188-1.813 4-4 4z" })))))))),
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-label": "Leave Gagl", className: "toolbox-button flex-row button_recordding background-hangup hover-button false undefined ", role: "button", tabIndex: 0, style: { position: 'relative', borderRadius: '4px' } },
                                                React.createElement("div", null,
                                                    React.createElement("div", null,
                                                        React.createElement("div", { className: "icon-button " },
                                                            React.createElement("div", { className: "jitsi-icon jitsi-icon-default " },
                                                                React.createElement("svg", { height: 22, width: 22, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 44 31" },
                                                                    React.createElement("image", { "data-name": "Vector Smart Object", width: 44, height: 31, xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAfCAYAAACcai8CAAAClUlEQVRYheWYv2sUQRTHP1mTgHJGPUURVE4RBVEQ/FEoKQ0KFipqpWhjo40kjf9FCkEQhBRpotiIjYooKCicgki0ELycFh5BxAj+CuHCV0ZmYVl393Z25zTgF4bZm3vz3vdm33znzfVIIicCYBuwG9gE1Gy/Elhq20CCq1lgBvhi+w9AA5gCXgMvgJ95SXQivBo4BhwF9gGVvI4dMA+8BO4Ct4A6kE7KEE5ouyTdkDSvv4+GpIuSKknc4gMrJI39A5JJmJZ0JovwFklTC4RsFBOSloQ8wxxeBzwH1nQhR33gAXAImAsJPwIGPTj+BkwD3yNjy4Flti+DUWDYED4M3HZ0ZGToqW2vbDMy9SNjTsVK4Q5gJ7Af2Av05YxpVna7yYubjjl1XVJ/irq4tmHH2JcDq68u6De5VPL1hkg6aLIwZAivdZyU+2jMgU+O9puDAqv11htdeOZoH/QCH62s5cWdDDvj76DtDdrWvp1ib47hN8DWnLE/Y4U5L+qSejI2Vi3BT63DRhxyKAEeBg6SZt7EKc85bHAPOBvT7jSMYSVqMuNXzUi6JmlDDskqssJhWyXpkqT3aasrKQiN10t6EvmyJemKpAOS+hy0tQzhsC2SdETSfZsqbUnjkgaitUSImt0wjYKv3sxvxsY2Au+K5Aqw2PKYDQd6YwZFHXcLf9xEggVGsCP+O8KngaqDfdXOKYyyhE8CLWC8Qz09aG1adk5xlCwPq5KaEQlL0tDoWNPOKRzT5X+JNJgi/LEtO7MwZ1e6XiaYj01nCIzksBspS/Y3PN0cOhVRE77i+EiJEBV7846XiqZ83AN89RHEpw6bG/Px2EXUPJ/wRZYuHBzm9nw+8vkCMOkzgM+UiOKqXYxzXr0CvwChP9p88bXmJQAAAABJRU5ErkJggg==" })))))))),
                                        React.createElement("div", { style: { marginLeft: '10px' } },
                                            React.createElement("div", { "aria-label": "toolbar.accessibilityLabel.requestUnmute", className: "toolbox-button flex-row toolbox-audio-toggle request-button hover-button undefined undefined ", role: "button", tabIndex: 0, style: { position: 'relative', borderRadius: '4px' } },
                                                React.createElement("div", null,
                                                    React.createElement("div", { style: { paddingRight: '8px', paddingLeft: '10px' } },
                                                        React.createElement("span", { style: { fontSize: '13px', textTransform: 'uppercase', fontWeight: 'bold' } }, "!"))))))),
                                React.createElement("div", { className: "audio-wave-box audio-wave-box-500 hidden-above-500" },
                                    React.createElement("div", { className: "audio-wave-box-mask", style: { width: '100%', animation: audioMovesFdr, animationDuration: '5s', animationIterationCount: 'infinite' } }))),
                            React.createElement("div", { style: { marginTop: '22px' } }))) : (''),
                        Object.keys(_participants).map((key, index) => {
                            var _a, _b, _c, _d, _e, _f;
                            return (key === 'local' ? (React.createElement("div", { id: 'localVideoTileViewContainer', style: {
                                    //@ts-ignore
                                    display: (((_a = _participants[key]) === null || _a === void 0 ? void 0 : _a.email) === ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.emailModerator) && ((_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.mode) === 'silent') || isDemo ? 'none' : 'block',
                                    paddingBottom: 22
                                } },
                                React.createElement(Thumbnail, { key: 'local', 
                                    //@ts-ignore
                                    participantID: (_f = _participants[key]) === null || _f === void 0 ? void 0 : _f.id }))) : key === 'remote' ? (
                            //@ts-ignore                                   
                            [..._participants[key].values()].map((x) => {
                                var _a, _b, _c, _d;
                                return (React.createElement("div", { id: '', style: {
                                        //@ts-ignore
                                        display: (x === null || x === void 0 ? void 0 : x.email) === ((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.emailModerator) && ((_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.mode) === 'silent' ? 'none' : 'block',
                                        paddingBottom: 22
                                    } },
                                    React.createElement(Thumbnail, { key: `remote_${x === null || x === void 0 ? void 0 : x.id}`, participantID: x === null || x === void 0 ? void 0 : x.id })));
                            })) : (''));
                        }))))));
    }
    /**
     * Handles mouse down on the drag handle.
     *
     * @param {MouseEvent} e - The mouse down event.
     * @returns {void}
     */
    _onDragHandleMouseDown(e) {
        const { _topPanelFilmstrip, _topPanelHeight, _verticalFilmstripWidth } = this.props;
        this.setState({
            isMouseDown: true,
            mousePosition: _topPanelFilmstrip ? e.clientY : e.clientX,
            dragFilmstripWidth: _verticalFilmstripWidth || DEFAULT_FILMSTRIP_WIDTH,
            dragFilmstripHeight: _topPanelHeight || TOP_FILMSTRIP_HEIGHT
        });
        this.props.dispatch(setUserIsResizing(true));
    }
    /**
     * Drag handle mouse up handler.
     *
     * @returns {void}
     */
    _onDragMouseUp() {
        if (this.state.isMouseDown) {
            this.setState({
                isMouseDown: false
            });
            this.props.dispatch(setUserIsResizing(false));
        }
    }
    /**
     * Handles drag handle mouse move.
     *
     * @param {MouseEvent} e - The mousemove event.
     * @returns {void}
     */
    _onFilmstripResize(e) {
        if (this.state.isMouseDown) {
            const { dispatch, _verticalFilmstripWidth, _maxFilmstripWidth, _topPanelHeight, _maxTopPanelHeight, _topPanelFilmstrip } = this.props;
            const { dragFilmstripWidth, dragFilmstripHeight, mousePosition } = this.state;
            if (_topPanelFilmstrip) {
                const diff = e.clientY - (mousePosition !== null && mousePosition !== void 0 ? mousePosition : 0);
                const height = Math.max(Math.min((dragFilmstripHeight !== null && dragFilmstripHeight !== void 0 ? dragFilmstripHeight : 0) + diff, _maxTopPanelHeight), TOP_FILMSTRIP_HEIGHT);
                if (height !== _topPanelHeight) {
                    dispatch(setUserFilmstripHeight(height));
                }
            }
            else {
                const diff = (mousePosition !== null && mousePosition !== void 0 ? mousePosition : 0) - e.clientX;
                const width = Math.max(Math.min((dragFilmstripWidth !== null && dragFilmstripWidth !== void 0 ? dragFilmstripWidth : 0) + diff, _maxFilmstripWidth), DEFAULT_FILMSTRIP_WIDTH);
                if (width !== _verticalFilmstripWidth) {
                    dispatch(setUserFilmstripWidth(width));
                }
            }
        }
    }
    /**
     * Calculates the start and stop indices based on whether the thumbnails need to be reordered in the filmstrip.
     *
     * @param {number} startIndex - The start index.
     * @param {number} stopIndex - The stop index.
     * @returns {Object}
     */
    _calculateIndices(startIndex, stopIndex) {
        const { _currentLayout, _iAmRecorder, _disableSelfView } = this.props;
        let start = startIndex;
        let stop = stopIndex;
        if (!_disableSelfView) {
            // In tile view, the indices needs to be offset by 1 because the first thumbnail is that of the local
            // endpoint. The remote participants start from index 1.
            if (!_iAmRecorder && _currentLayout === LAYOUTS.TILE_VIEW) {
                start = Math.max(startIndex - 1, 0);
                stop = stopIndex - 1;
            }
        }
        return {
            startIndex: start,
            stopIndex: stop
        };
    }
    /**
     * Toggle the toolbar visibility when tabbing into it.
     *
     * @returns {void}
     */
    _onTabIn() {
        if (!this.props._isToolboxVisible && this.props._mainFilmstripVisible) {
            this.props.dispatch(showToolbox());
        }
    }
    /**
     * The key to be used for every ThumbnailWrapper element in stage view.
     *
     * @param {number} index - The index of the ThumbnailWrapper instance.
     * @returns {string} - The key.
     */
    _listItemKey(index) {
        const { _remoteParticipants, _remoteParticipantsLength } = this.props;
        if (typeof index !== 'number' || _remoteParticipantsLength <= index) {
            return `empty-${index}`;
        }
        return _remoteParticipants[index];
    }
    /**
     * The key to be used for every ThumbnailWrapper element in tile views.
     *
     * @param {Object} data - An object with the indexes identifying the ThumbnailWrapper instance.
     * @returns {string} - The key.
     */
    _gridItemKey({ columnIndex, rowIndex }) {
        const { _disableSelfView, _columns, _iAmRecorder, _remoteParticipants, _remoteParticipantsLength } = this.props;
        const index = (rowIndex * _columns) + columnIndex;
        // When the thumbnails are reordered, local participant is inserted at index 0.
        const localIndex = _disableSelfView ? _remoteParticipantsLength : 0;
        const remoteIndex = !_iAmRecorder && !_disableSelfView ? index - 1 : index;
        if (index > _remoteParticipantsLength - (_iAmRecorder ? 1 : 0)) {
            return `empty-${index}`;
        }
        if (!_iAmRecorder && index === localIndex) {
            return 'local';
        }
        return _remoteParticipants[remoteIndex];
    }
    /**
     * Handles items rendered changes in stage view.
     *
     * @param {Object} data - Information about the rendered items.
     * @returns {void}
     */
    _onListItemsRendered({ visibleStartIndex, visibleStopIndex }) {
        const { dispatch } = this.props;
        const { startIndex, stopIndex } = this._calculateIndices(visibleStartIndex, visibleStopIndex);
        dispatch(setVisibleRemoteParticipants(startIndex, stopIndex));
    }
    /**
     * Handles items rendered changes in tile view.
     *
     * @param {Object} data - Information about the rendered items.
     * @returns {void}
     */
    _onGridItemsRendered({ visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex }) {
        const { _columns, dispatch } = this.props;
        const start = (visibleRowStartIndex * _columns) + visibleColumnStartIndex;
        const stop = (visibleRowStopIndex * _columns) + visibleColumnStopIndex;
        const { startIndex, stopIndex } = this._calculateIndices(start, stop);
        dispatch(setVisibleRemoteParticipants(startIndex, stopIndex));
    }
    /**
     * Renders the thumbnails for remote participants.
     *
     * @returns {ReactElement}
     */
    _renderRemoteParticipants() {
        const { _columns, _currentLayout, _filmstripHeight, _filmstripWidth, _hasScroll, _isVerticalFilmstrip, _remoteParticipantsLength, _resizableFilmstrip, _rows, _thumbnailHeight, _thumbnailWidth, _verticalViewGrid, filmstripType } = this.props;
        if (!_thumbnailWidth || isNaN(_thumbnailWidth) || !_thumbnailHeight
            || isNaN(_thumbnailHeight) || !_filmstripHeight || isNaN(_filmstripHeight) || !_filmstripWidth
            || isNaN(_filmstripWidth)) {
            return null;
        }
        if (_currentLayout === LAYOUTS.TILE_VIEW || _verticalViewGrid || filmstripType !== FILMSTRIP_TYPE.MAIN) {
            return (React.createElement(FixedSizeGrid, { className: 'filmstrip__videos remote-videos', columnCount: _columns, columnWidth: _thumbnailWidth + TILE_HORIZONTAL_MARGIN, height: _filmstripHeight, initialScrollLeft: 0, initialScrollTop: 0, itemData: { filmstripType }, 
                // @ts-ignore
                itemKey: this._gridItemKey, onItemsRendered: this._onGridItemsRendered, overscanRowCount: 1, rowCount: _rows, rowHeight: _thumbnailHeight + TILE_VERTICAL_MARGIN, width: _filmstripWidth }, ThumbnailWrapper));
        }
        const props = {
            itemCount: _remoteParticipantsLength,
            className: `filmstrip__videos remote-videos ${_resizableFilmstrip ? '' : 'height-transition'}`,
            height: _filmstripHeight,
            itemKey: this._listItemKey,
            itemSize: 0,
            onItemsRendered: this._onListItemsRendered,
            overscanCount: 1,
            width: _filmstripWidth,
            style: {
                willChange: 'auto'
            }
        };
        if (_currentLayout === LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW) {
            const itemSize = _thumbnailWidth + TILE_HORIZONTAL_MARGIN;
            const isNotOverflowing = !_hasScroll;
            props.itemSize = itemSize;
            props.layout = 'horizontal';
            if (isNotOverflowing) {
                props.className += ' is-not-overflowing';
            }
        }
        else if (_isVerticalFilmstrip) {
            const itemSize = _thumbnailHeight + TILE_VERTICAL_MARGIN;
            const isNotOverflowing = !_hasScroll;
            if (isNotOverflowing) {
                props.className += ' is-not-overflowing';
            }
            props.itemSize = itemSize;
        }
        return (React.createElement(FixedSizeList, Object.assign({}, props), ThumbnailWrapper));
    }
    /**
     * Dispatches an action to change the visibility of the filmstrip.
     *
     * @private
     * @returns {void}
     */
    _doToggleFilmstrip() {
        const { dispatch, _mainFilmstripVisible, _topPanelFilmstrip, _topPanelVisible } = this.props;
        _topPanelFilmstrip
            ? dispatch(setTopPanelVisible(!_topPanelVisible))
            : dispatch(setFilmstripVisible(!_mainFilmstripVisible));
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling filmstrip visibility.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleFilmstrip() {
        sendAnalytics(createShortcutEvent('toggle.filmstrip', ACTION_SHORTCUT_TRIGGERED, {
            enable: this.props._mainFilmstripVisible
        }));
        this._doToggleFilmstrip();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for opening
     * the speaker stats modal.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleFilmstrip() {
        sendAnalytics(createToolbarEvent('toggle.filmstrip.button', {
            enable: this.props._mainFilmstripVisible
        }));
        this._doToggleFilmstrip();
    }
    /**
     * Handler for touch start event of the 'toggle button'.
     *
     * @private
     * @param {Object} e - The synthetic event.
     * @returns {void}
     */
    _onToggleButtonTouch(e) {
        // Don't propagate the touchStart event so the toolbar doesn't get toggled.
        e.stopPropagation();
        this._onToolbarToggleFilmstrip();
    }
    /**
     * Creates a React Element for changing the visibility of the filmstrip when
     * clicked.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderToggleButton() {
        const { t, classes, _isVerticalFilmstrip, _mainFilmstripVisible, _topPanelFilmstrip, _topPanelVisible } = this.props;
        const icon = (_topPanelFilmstrip ? _topPanelVisible : _mainFilmstripVisible) ? IconArrowDown : IconArrowUp;
        const actions = isMobileBrowser()
            ? { onTouchStart: this._onToggleButtonTouch }
            : { onClick: this._onToolbarToggleFilmstrip };
        return (React.createElement("div", { className: clsx(classes.toggleFilmstripContainer, _isVerticalFilmstrip && classes.toggleVerticalFilmstripContainer, _topPanelFilmstrip && classes.toggleTopPanelContainer, _topPanelFilmstrip && !_topPanelVisible && classes.toggleTopPanelContainerHidden, 'toggleFilmstripContainer') },
            React.createElement("button", Object.assign({ "aria-expanded": this.props._mainFilmstripVisible, "aria-label": t('toolbar.accessibilityLabel.toggleFilmstrip'), className: classes.toggleFilmstripButton, id: 'toggleFilmstripButton', onFocus: this._onTabIn, tabIndex: 0 }, actions),
                React.createElement(Icon, { "aria-label": t('toolbar.accessibilityLabel.toggleFilmstrip'), src: icon }))));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code Filmstrip}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state, ownProps) {
    const { _hasScroll = false, filmstripType, _topPanelFilmstrip, _remoteParticipants } = ownProps;
    const toolbarButtons = getToolbarButtons(state);
    const { iAmRecorder } = state['features/base/config'];
    const { topPanelHeight, topPanelVisible, visible, width: verticalFilmstripWidth } = state['features/filmstrip'];
    const { localScreenShare } = state['features/base/participants'];
    const reduceHeight = state['features/toolbox'].visible && toolbarButtons.length;
    const remoteVideosVisible = shouldRemoteVideosBeVisible(state);
    const { isOpen: shiftRight } = state['features/chat'];
    const disableSelfView = shouldHideSelfView(state);
    const { clientWidth, clientHeight } = state['features/base/responsive-ui'];
    const collapseTileView = reduceHeight
        && isMobileBrowser()
        && clientWidth <= ASPECT_RATIO_BREAKPOINT;
    const shouldReduceHeight = reduceHeight && isMobileBrowser();
    const _topPanelVisible = isStageFilmstripTopPanel(state) && topPanelVisible;
    let isVisible = visible || filmstripType !== FILMSTRIP_TYPE.MAIN;
    if (_topPanelFilmstrip) {
        isVisible = _topPanelVisible;
    }
    const videosClassName = `filmstrip__videos${isVisible ? '' : ' hidden'}${_hasScroll ? ' has-scroll' : ''}`;
    const className = `${remoteVideosVisible || ownProps._verticalViewGrid ? '' : 'hide-videos'} ${shouldReduceHeight ? 'reduce-height' : ''} ${shiftRight ? 'shift-right' : ''} ${collapseTileView ? 'collapse' : ''} ${isVisible ? '' : 'hidden'}`.trim();
    const _currentLayout = getCurrentLayout(state);
    const _isVerticalFilmstrip = _currentLayout === LAYOUTS.VERTICAL_FILMSTRIP_VIEW
        || (filmstripType === FILMSTRIP_TYPE.MAIN && _currentLayout === LAYOUTS.STAGE_FILMSTRIP_VIEW);
    const settings = state['features/base/settings'];
    return {
        _className: className,
        _chatOpen: state['features/chat'].isOpen,
        _currentLayout,
        _disableSelfView: disableSelfView,
        _hasScroll,
        _iAmRecorder: Boolean(iAmRecorder),
        _isFilmstripButtonEnabled: isButtonEnabled('filmstrip', state),
        _isToolboxVisible: isToolboxVisible(state),
        _isVerticalFilmstrip,
        _localScreenShare: localScreenShare,
        _mainFilmstripVisible: visible,
        _maxFilmstripWidth: clientWidth - MIN_STAGE_VIEW_WIDTH,
        _maxTopPanelHeight: clientHeight - MIN_STAGE_VIEW_HEIGHT,
        _remoteParticipantsLength: _remoteParticipants === null || _remoteParticipants === void 0 ? void 0 : _remoteParticipants.length,
        _topPanelHeight: topPanelHeight.current,
        _topPanelMaxHeight: topPanelHeight.current || TOP_FILMSTRIP_HEIGHT,
        _topPanelVisible,
        _verticalFilmstripWidth: verticalFilmstripWidth.current,
        _verticalViewMaxWidth: getVerticalViewMaxWidth(state),
        _videosClassName: videosClassName,
        _participants: state['features/base/participants'],
        settings
    };
}
export default withStyles(styles)(translate(connect(_mapStateToProps)(Filmstrip)));
